module.exports = __webpack_public_path__ + "img/arr-l-w.d998ab29.svg";